export default "__VITE_ASSET__D21Y2l$0__"